import React from 'react';
import './style.css';
import config from '../config';
import {
  Grid,
  Row,
  Col
} from 'react-bootstrap/lib';
import LoadingTemplate from './loading-template';
import SuccessTemplate from './success-template';
import PropTypes from 'prop-types';

const {apiUrl} = config;
class Confirmation extends React.Component {
  constructor(props) {
    super(props);
    const {match: {params: {jwt}}} = props;
    this.state = {
      errorStatus: null,
      loading: true
    };
    fetch(`${apiUrl}/coins/validation/${jwt}`)
      .then(resp => {
        if (resp.status !== 200) {
          throw {
            status: resp.status
          };
        } else {
          return resp.json();
        }
      })
      .then(() => {
        this.setState({loading: false});
      })
      .catch(err => {
        this.setState({
          loading: false,
          errorStatus: err.status || 'UNKNOWN_ERROR'
        });
      });
  }
  render() {
    return (
      <Grid>
        <Row>
          <Col xs={12}>
            {this.state.loading && <LoadingTemplate />}
            {!this.state.loading && !this.state.errorStatus && <SuccessTemplate />}
          </Col>
        </Row>
      </Grid>
    );
  }
}

Confirmation.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      jwt: PropTypes.string
    })
  })
};

export default Confirmation;



// WEBPACK FOOTER //
// ./src/confirmation/index.js